import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { Classifica } from 'src/app/shared/models/classifica.model';
import { Qualifica } from 'src/app/shared/models/qualifica.model';
import { Sezione } from 'src/app/shared/models/sezione.model';

@Component({
  selector: 'app-table-sezioni',
  templateUrl: './table-sezioni.component.html',
  styleUrls: ['./table-sezioni.component.scss']
})
export class TableSezioniComponent implements OnInit {
  public editMode: 'new' | 'edit';
  public form: FormGroup;
  public sezioni$: Observable<Sezione[]>;
  public sezioneInEdit: Sezione;
  public isDialogOpen = false;
  public classifiche: Classifica[];
  public qualifiche: Qualifica[];

  constructor(
    private anagraficheService: AnagraficheService,
    private messageService: MessageService
  ) { }

  public ngOnInit(): void {
    this.sezioni$ = this.anagraficheService.sezioni.getAll();
    this.anagraficheService.classifiche.getAllArray(c => this.classifiche = c);
    this.anagraficheService.qualifiche.getAllArray(q => this.qualifiche = q);

    this.form = new FormGroup({
      nomeSezione: new FormControl(null, Validators.required),
      descrizione: new FormControl(null),
      classifica: new FormControl(null, Validators.required),
      qualifica: new FormControl(null, Validators.required),
      esercitazione: new FormControl(false, Validators.required)
    });
  }

  public openModal(mode: 'new' | 'edit', item?: Sezione): void {
    this.isDialogOpen = true;
    this.editMode = mode;
    this.sezioneInEdit = item;
    this.form.controls.nomeSezione.setValue(item ? item.nomeSezione : null);
    this.form.controls.descrizione.setValue(item ? item.descrizione : null);
    this.form.controls.classifica.setValue(item ? this.getClassifica(item) : null);
    this.form.controls.qualifica.setValue(item ? this.getQualifica(item) : null);
    this.form.controls.esercitazione.setValue(item ? item.esercitazione : false);

    setTimeout(() => {
      document.getElementById('name').focus();
    }, 50);
  }

  public resetForm(): void {
    this.isDialogOpen = false;
    this.editMode = undefined;
    this.sezioneInEdit = null;
    this.form.reset();
  }

  public saveItem(): void {
    if (this.editMode === 'new') {
      const item = {
        nomeSezione: this.form.controls.nomeSezione.value as string,
        descrizione: this.form.controls.descrizione.value as string,
        classificaId: (this.form.controls.classifica.value as Classifica).classificaId,
        qualificaId: (this.form.controls.qualifica.value as Qualifica).qualificaId,
        esercitazione: this.form.controls.esercitazione.value as boolean
      } as Sezione;

      this.anagraficheService.sezioni.create(item).subscribe(
        _ => this.handleSuccess('Creazione'),
        err => this.handleError(err)
      );
    } else {
      const item = { ...this.sezioneInEdit };
      item.nomeSezione = this.form.controls.nomeSezione.value as string;
      item.descrizione = this.form.controls.descrizione.value as string;
      item.classificaId = (this.form.controls.classifica.value as Classifica).classificaId;
      item.qualificaId = (this.form.controls.qualifica.value as Qualifica).qualificaId;
      item.esercitazione = this.form.controls.esercitazione.value as boolean;

      this.anagraficheService.sezioni.update(item).subscribe(
        _ => this.handleSuccess('Modifica'),
        err => this.handleError(err)
      );
    }
  }

  public removeItem(item: Sezione): void {
    this.anagraficheService.sezioni.delete(item).subscribe(
      _ => this.handleSuccess('Eliminazione'),
      err => this.handleError(err)
    );
  }

  public getQualifica(sezione: Sezione): Qualifica {
    return this.qualifiche?.find(q => q.qualificaId === sezione.qualificaId);
  }

  public getClassifica(sezione: Sezione): Classifica {
    return this.classifiche?.find(q => q.classificaId === sezione.classificaId);
  }

  private handleSuccess(operation: string) {
    this.message('success', operation, `${operation} Sezione completata`);
    this.resetForm();
  }

  private handleError(err: Error): void {
    if (err instanceof HttpErrorResponse && err.status === 409) {
      this.message('error', 'Errore', err.error);
    } else {
      this.message('error', 'Errore', `Si è verificato un errore. Operazione non completata`);
      this.resetForm();
    }
  }

  private message(sev: string, sum: string, det: string) {
    this.messageService.add({
      key: 'toast',
      severity: sev,
      summary: sum,
      detail: det
    });
  }
}
